<template>
<m-pageframe
    title="{organization-label}: RedChirp Billing Settings"
>
<v-container
    fluid
    style="padding: 15px; padding-left: 30px; padding-right: 30px;"
>

    <m-redchirp-payment-org-controlled-billing-settings
        :organization_id="$route.params.organization_id"
    />

    <m-redchirp-payment-methods  
        :organization_id="$route.params.organization_id"
    />

    <div
        v-if="$rc.$state.isOrganizationAdmin()"
    >
        <b>RedChirp Invoices</b>

        <v-data-table
            v-if="invoices != null"
            :headers="invoice_headers"
            :items="invoices"
            :items-per-page="100"
            class="elevation-1"
            :hide-default-footer="true"
            disable-sort
            :footer-props="{
                disableItemsPerPage: false,
                disablePagination: false,
            }"
            style="margin-top: 15px"
        >
        
            <template v-slot:item.action="{ item }">
                <v-menu 
                    bottom 
                    offset-y  
                >
                
                <template v-slot:activator="{ on }">
                        
                    <v-icon 
                        v-on="on"
                    >
                        mdi-dots-vertical-circle-outline
                    </v-icon>
                        
                </template>
                
                <v-list>
                    <v-list-item
                        v-on:click="onClickOpenInvoice(item)"
                    >
                        <v-list-item-title>Open Invoice...</v-list-item-title>
                    </v-list-item>
                
                </v-list>
                
                </v-menu> 
            </template>
        
        </v-data-table>
    </div>

    <div
        style="margin-top: 15px"
    >
        <b>RedChirp Form W-9</b>
        <p
            style="margin-top: 15px"
        >
            You can download RedChirp's form W-9 <a href="https://files.redchirp.com/red-chirp-w9.pdf" target="_blank">here</a>.
        </p>
    </div>

    <div
        v-if="this.$rc.$state.isAuthActorSystemAdmin()"
        style="border: 1px solid rgba(0,0,0,0.2); padding: 15px; border-radius: 15px; margin-top: 30px;"
    >
        <p><b>System administrators only</b></p>

        <p>
            The best practice is to collect payment method information from the client using the secure provide payment method link.  This link does not require that the recipient be able to log into RedChirp.  Please note that this link is specific to the organization.
        </p>

        <p>
            Should you need to enter a payment method for a customer you should open the (below) link in a private browsing window and enter the payment information as a customer would.
        </p>

        <m-edit-text
            label="Secure Provide RedChirp Payment Method Link"
            :value="$rc.linkProvideRedChirpPaymentMethod($router, $route.params.organization_id)"
            read_only
        />

    </div>

</v-container>
</m-pageframe>
</template>

<script>
export default {

    data() {
        return {
            invoices: [],
            invoice_headers: [
                { text: 'Date', value: 'invoice_date'},
                { text: 'Invoice Number', value: 'doc_number'},
                { text: 'Customer Name', value: 'intuit_customer_name'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.updateInvoices();
    },

    methods: {
        updateInvoices() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/integrations/invoices',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.invoices = data.results;
                    },
            
                'on_error': 'Unable to list invoices',
            });
        },

        onClickOpenInvoice(item)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/integrations/invoices/download',
            
                'params' : {
                        'invoice_id': item.invoice_id,
                        'timeout': 30*60*1000,
                    },
            
                'on_success': (data) => {
                        window.open(data.invoice_pdf_url, '_blank');
                    },
            
                'on_error': 'Unable to download invoice PDF',
            });
        },

    },

}
</script>

<style lang="scss" scoped>
</style>